/**
 * @param {Number} input
 * @returns {string}
 */
export const numberFilter = (input) => {
    return Intl.NumberFormat().format(input);
};
